import { createSelector } from "reselect";
import { getEnabledFeatures } from "../../../data/entity";

export const getSearchQuery = (state) =>
  state.giving_form.allocation_selection.get("query");
export const getAllocations = (state) =>
  state.giving_form.allocation_selection.get("allocations");
export const getCentralizedGifts = (state) =>
  state.giving_form.allocation_selection.get("centralizedGifts");
export const getDonation = (state) =>
  state.giving_form.allocation_selection.get("donationId");
export const getFormSubmitting = (state) =>
  state.giving_form.allocation_selection.get("formSubmitting");
export const getHasFetched = (state) =>
  state.giving_form.allocation_selection.get("fetchedAllocations");
export const getLoading = (state) =>
  state.giving_form.allocation_selection.get("isLoading");
export const getSelectedAllocations = (state) =>
  state.giving_form.allocation_selection.get("selectedAllocations");
export const getSubmitError = (state) =>
  state.giving_form.allocation_selection.get("submitError");
export const getTotalAmount = (state) =>
  state.giving_form.allocation_selection.get("totalAmount");
export const getFeeAmount = (state) =>
  state.giving_form.allocation_selection.get("feeAmount");
export const getSelectedCategory = (state) =>
  state.giving_form.allocation_selection.get("selectedCategory");
export const getGatewayError = (state) =>
  state.giving_form.allocation_selection.get("gatewayError");
export const getHasMounted = (state) =>
  state.giving_form.allocation_selection.get("hasMounted");
export const getMinimumValueError = (state) =>
  state.giving_form.allocation_selection.get("minimumValueError");
export const getConfirming = (state) =>
  state.giving_form.allocation_selection.get("confirming");
export const getAddingGift = (state) =>
  state.giving_form.allocation_selection.get("addingGift");
export const getStripePaymentId = (state) =>
  state.giving_form.allocation_selection.get("stripePaymentId");
export const getConnectedStripeAccountId = (state) =>
  state.giving_form.allocation_selection.get("connectedStripeAccountId");
export const getStripeClientSecretKey = (state) =>
  state.giving_form.allocation_selection.get("stripeClientSecretKey");
export const getDonationToken = (state) =>
  state.giving_form.allocation_selection.get("donationToken");
export const getStripePublishableKey = (state) =>
  state.giving_form.allocation_selection.get("stripePublishableKey");
export const getStripeObject = (state) =>
  state.giving_form.allocation_selection.get("stripeObject");
export const getStripeElementsObject = (state) =>
  state.giving_form.allocation_selection.get("stripeElementsObject");
export const getIsGiftAid = (state) =>
  state.giving_form.allocation_selection.get("isGiftAid");
export const getAmountWithGiftAid = (state) =>
  state.giving_form.allocation_selection.get("amountWithGiftAid");
export const getStripePaymentIntentId = (state) =>
  state.giving_form.allocation_selection.get("stripePaymentIntentId");

export const getAllocationType = (state) => {
  return "campaign";
};

export const getFilteredAllocations = createSelector(
  [getAllocations, getSearchQuery, getSelectedCategory, getAllocationType],
  (items, query, category, allocationType) => {
    if (allocationType === "campaign") {
      const nameMatch = (campaign) =>
        campaign.get("name").toLowerCase().includes(query.toLowerCase());

      const categoryMatch = (campaign) =>
        (campaign.get("category") || "").toLowerCase().includes(query.toLowerCase());

      const filteredByQuery = items
        .filter((item) => nameMatch(item) || categoryMatch(item))
        .sort((campaignA, campaignB) => {
          if (nameMatch(campaignA) && !nameMatch(campaignB)) {
            return -1;
          } else if (!nameMatch(campaignA) && nameMatch(campaignB)) {
            return 1;
          }
          return 0;
        });

      if (!category) {
        return filteredByQuery;
      }

      return filteredByQuery.filter((item) => {
        if (item.get("category")) {
          return item.get("category").toLowerCase() === category.toLowerCase();
        }
      });
    }

    if (!query) {
      return items;
    }

    const filteredByQuery = items.filter((item) => {
      return item.get("name").toLowerCase().includes(query.toLowerCase());
    });

    return filteredByQuery;
  },
);
